import React, { useState } from "react";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput,
    Accordion,
    Checkbox,
    ScrollArea,
    Divider
} from '@mantine/core';
import { Calendar } from '@mantine/dates';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX
} from '@tabler/icons';

import pagani from '../assets/pagani.jpg';

const useStyles = createStyles((theme) => ({
    msg: {
        textAlign: 'center'
    },
    timeBlockContain: {//needed:turn into timeBlockAvailable
        contentAlign: 'center',
        width: '100%',
        height: '40px',
        //textAlign: 'center',
        backgroundColor: 'white',
        borderBottom: 'solid 1px black'
    },
    filledTimeBlock: {//needed:turn into timeBlockFilled
        width: '100%',
        height: '40px',
        backgroundColor: 'grey',
        borderBottom: 'solid 1px black'
    }
}));


//needed:doc only a message property is needed
/*
 *!!!!programmatically create timeslots!!!!
 * FLOW
 * properties needed:
 *  - time slot range
 *  - useSelector to find available slots for the day or to see filled in slots(depending on ctx)
 *  - add onclick to each div
 *  
 * */
export function SchedulerDayCard({message}){
    const { classes } = useStyles();
    
    
    
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Text>
                    {message.toString()}
                    </Text>
                </Card.Section>
                <Card.Section>
                    <ScrollArea style={{ height: 400 }} offsetScrollbars>
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                1:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                1:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain,classes.filledTimeBlock}>
                            <Text c="dimmed">
                                2:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                2:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                3:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                3:30AM 
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                4:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                4:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                5:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                5:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                6:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                6:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                7:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                7:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                8:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                8:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                9:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                9:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                10:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                10:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                10:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                11:00AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                11:30AM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                12:00PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                12:30PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                01:00PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                01:30PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                02:00PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                02:30PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                03:00PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                03:30PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                04:00PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        <div className={classes.timeBlockContain}>
                            <Text c="dimmed">
                                04:30PM
                            </Text>
                        </div>
                        <Divider variant="dashed" />
                        
                    </ScrollArea>
                </Card.Section>
            </Card>
        </>
    )
}

